(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupController', ReportGroupController);

    ReportGroupController.$inject = ['$scope', '$state', 'ReportGroup', 'ReportGroupSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function ReportGroupController ($scope, $state, ReportGroup, ReportGroupSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.reportGroups = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  ReportGroup.query(function(result) {
                  vm.reportGroups = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.reportGroups, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            ReportGroup.query(function(result) {
                vm.reportGroups = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();
